var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 19.009,
    viewBox: "0 0 19.049 19.009",
    width: 19.049,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.94,5480.579H240.99",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(-223.94 -5477.333)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(0.902 2.629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.15932559967041 2.000001907348633 L 3.032476425170898 13.38026142120361 L 12.1605978012085 13.38026142120361 L 13.03374862670898 2.000001907348633 L 2.15932559967041 2.000001907348633 M -2.86102294921875e-06 1.9073486328125e-06 L 15.19307708740234 1.9073486328125e-06 L 14.01302719116211 15.38026142120361 L 1.180047035217285 15.38026142120361 L -2.86102294921875e-06 1.9073486328125e-06 Z",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.453 7.889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H4.456",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H4.456",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(4.143) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1068.611,5111.666v-3.246h5.844v3.246",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(-1063.008 -5108.42)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonTrash);
export default __webpack_public_path__ + "static/media/Ikon_Trash.4c9bc3c892b65425c0feaf68310dd6e4.svg";
export { ForwardRef as ReactComponent };